import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAlertHook } from 'app/hooks';
import { DropDownItem, Dropdown, Icon } from "app/components";
import { Notification } from "ais-facade-api/api";


import styles from './NotificationsActionCell.module.scss';

interface Props {
  notification: Notification;
}

export const NotificationsActionCell = ({ notification }: Props) => {
  const { t } = useTranslation();
  const { addAlert } = useAlertHook();
  const [dropdown, setDropdown] = useState(false);

  const handleClickCopyClipboard = () => {
    notification &&
      navigator.clipboard.writeText(`${notification.dt};${notification.message}`)
        .then(() => {
          addAlert({
            data: {
              messages: [{ description: t('ClipboardCopySuccess'), type: 'information' }],
            },
          })
          setDropdown(false);
        });
  };

  return (
    <>
      <button
        className={styles.icon_button}
        aria-expanded={dropdown ? 'true' : 'false'}
        onClick={() => setDropdown((prev) => !prev)}
      >
        <Icon name="more-icon" color="var(--default-primary)" width="13px" height="3px" />
      </button>

      <Dropdown
        dropdown={dropdown}
        onClickOutside={() => {
          setDropdown(false);
        }}
      >
        <DropDownItem>
          <button
            className={styles.button}
            onClick={handleClickCopyClipboard}
          >
            {t('ClipboardCopy')}
          </button>
        </DropDownItem>
      </Dropdown>
    </>
  )
}